import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "confused-person",
  "use": "confused-person-usage",
  "viewBox": "0 0 138 138",
  "content": "<symbol viewBox=\"0 0 138 138\" id=\"confused-person\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <circle cx=\"69\" cy=\"69\" r=\"65\" stroke=\"#DCDCDC\" stroke-width=\"8\" />\n        <circle cx=\"89.5\" cy=\"62.5\" r=\"6.5\" fill=\"#DCDCDC\" />\n        <circle cx=\"49.5\" cy=\"62.5\" r=\"6.5\" fill=\"#DCDCDC\" />\n        <path stroke=\"#DCDCDC\" stroke-linecap=\"round\" stroke-width=\"5\" d=\"M44 93.281c15.854-7.9 19.771 4.281 30.643 4.281 10.87 0 19.823-8.562 19.823-8.562\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/confused-person.svg
// module id = ./src/assets/img/confused-person.svg
// module chunks = 2